import React from 'react';
import { view } from '@aha-app/react-easy-state';

const ReadOnlyPrompt = ({ prompt }) => {
  return (
    <div>
      <label className='control-label'>
        {prompt.title}: {prompt.value}
      </label>
    </div>
  );
};

export default view(ReadOnlyPrompt);
